
import FaqItem from '~/components/specialist/faq-item.vue'
import Title from '~/components/specialist/section-title.vue'

export default {
  name: 'SpecialistFaq',
  components: {
    Title,
    FaqItem
  },
  data() {
    return {
      categories: [
        {
          title: 'DeNAのAI・組織について',
          qas: [
            {
              q: 'DeNAの「AI-ALL-IN（AIオールイン）」とは？',
              a: 'AIオールイン戦略は、全社員がAI活用に取り組み、既存事業の競争力強化、新規事業創出、生産性向上を推進する全社方針です。AI Specialistは高度な専門性を発揮し、その実践を技術面から牽引します。'
            },
            {
              q: 'AI Specialistはどんな役割を担っていますか？',
              a: '多様な事業の現場で、事業価値の大きい課題を見極め、AI技術によってその解決や成長を実現・加速する役割です。課題設定から技術選定・検証、事業実装まで一貫して関わり、AI技術の専門家として技術を事業に取り込み、中長期で事業変革を牽引する、技術と事業の交差点に立つ存在です。'
            },
            {
              q: '「AI Specialist」と「AI Generalist」は何が違いますか？',
              a: 'AI Specialistは専門技術を軸に事業課題の解決をリードする存在です。一方DeNAでは全職種がAIを使いこなすことを前提としており、その総称を「AI Generalist」と呼んでいます。'
            }
          ]
        },
        {
          title: '技術・取り組みについて',
          qas: [
            {
              q: 'どんな技術領域に取り組んでいますか？',
              a: 'データサイエンス、LLM・生成AI、コンピュータービジョン、強化学習、音声合成、音声対話など幅広くAIに関する技術領域に取り組んでいます。'
            },
            {
              q: 'AI Specialistは1つの専門領域に特化しているのですか？',
              a: '必ずしもそうではありません。1つの技術を深く突き詰める人もいれば、複数領域を横断する人、事業の中に入ってプロダクト開発まで担う人もいます。役割の幅が広いのが特徴です。'
            },
            {
              q: 'どんな事業・サービスでAIが活かされていますか？',
              a: 'ゲーム・スポーツ・業務効率化・AIをコアとした新規事業など多様な事業領域で活用しています。スポーツ領域ではバスケや野球のチーム力強化、ソフトウェアテストにおける自動化、AIライバーなど実サービスに直結したテーマに取り組んでいます。'
            }
          ]
        },
        {
          title: '環境・実績について',
          qas: [
            {
              q: '技術力を磨ける文化・制度はありますか？',
              a: 'DeNAには、技術力を継続的に磨ける文化と制度があります。たとえば、業務時間を活用してKaggleなどの外部コンペに参加できる社内ランク制度（コンペ成績条件あり）や、毎週開催される社内勉強会があります。また、事業やチームを越えて知見を共有し合う文化があり、日々の事業応用の中でも多様な技術課題に触れながら、実践を通じて専門性を高められる環境です。'
            },
            {
              q: 'これまでどんな成果がありますか？',
              a: '例として、Kaggle「NFL Big Data Bowl 2026」で当社のデータサイエンティストが5位・金メダルを獲得。Competition Grandmasterが4名、Masterが7名在籍しています（2026年7月時点）。'
            },
            {
              q: 'どんなスキル・経験を持つ人が活躍していますか？',
              a: 'いずれかのAI技術領域（データサイエンス／LLM・生成AIコンピュータビジョン／強化学習など）において、研究・実務経験を持つ方や、Kaggleなどのコンペで上位成績を収めた方が活躍しています。加えて、技術力を磨くだけでなく、その専門性を事業課題の解決や価値創出につなげようとする姿勢を大切にしています。研究バックグラウンドを持つ方から、業務での実装経験を重ねてきた方まで、多様な人材が活躍しています。'
            }
          ]
        }
      ]
    }
  }
}
